import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Grupos, User } from '../cliente-grupo-investimento.model';

const BASE_PATH = environment.basePath;
const basePathExternalApi = environment.basePathExternalApi;
const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

@Injectable({
  providedIn: 'root',
})
export class ClienteGrupoInvestimentoService {
  constructor(private _$http: HttpClient) {}

  getInvestmentGroups() {
    return (
      this._$http
        //.get<Grupo[]>(`http://localhost:4004/grupos`)
        .get<Grupos>(
          `${BASE_PATH}/bff/master-bo/create-user/set-investment-groups/groups/list`,
        )
        .toPromise()
    );
  }

  getUser(payload: string) {
    return this._$http
      .post<User>(`${BASE_PATH}/bff/users/findById`, payload, { headers: headers })
      .toPromise();
  }
  getFunds(){
    return this._$http.get<any[]>(`${basePathExternalApi}/getEligibalFundsperUser`,{ headers: headers })
  }
}
